import { render, staticRenderFns } from "./OffreViewPage.vue?vue&type=template&id=c35ae414&scoped=true&"
import script from "./OffreViewPage.vue?vue&type=script&lang=js&"
export * from "./OffreViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ae414",
  null
  
)

export default component.exports